const lang = {
  en: {
    alerts: {
      address: {
        valid: "Address is valid!",
        suggestions_found: "Address is valid!",
        formatted_no_suggestions: "Address is valid!",
      },
      active_mail_classes: {
        updated: "Active mail classes updated!",
      },
    },

    shipping_rules: {
      signature: {
        ADSIGRD: "Adult Signature Required / Restricted Delivery - $9.35",
        ADSIG: "Adult Signature Confirmation - $9.05",
        DelCon: "Delivery Confirmation",
        Sig: "Signature Confirmation - $3.40",
      },
      package: {
        IRRPKG: "Irregular Package",
        PKG: "Package (your box/polybag)",
        FRB: "Medium Flat Rate Box",
      },
    },

    marketplaces: {
      ebay: {
        id: "Item Number",
      },
      shopify: {
        id: "Order Number",
      },
      amazon: {
        id: "Order Number",
      },
    },

    label_status: {
      label_created: "Label Created",
      in_transit: "In Transit",
      delivered: "Delivered",
      voided: "Voided",
      accepted: "Accepted",
      exception: "Exception",
      undelivered: "Undelivered",
    },

    refund_status: {
      requested: "Submitted",
      approved: "Approved",
      accepted: "Accepted",
      denied: "Denied",
      exception: "Denied",
      undelivered: "Undelivered",
    },

    status_return: {
      label_created: "Label Created",
      in_transit: "In Transit",
      delivered: "Delivered",
      voided: "Voided",
      exception: "Exception",
      undelivered: "Undelivered",
      // printed: 'Printed',
      // charged: 'Charged',
    },
    // added for table
    return_status: {
      printed: "No",
      charged: "Yes",
    },

    status: {
      label_created: "Label Created",
      in_transit: "In Transit",
      voided: "Voided",
      printed: "Printed",
      charged: "Charged",
      delivered: "Delivered",
      requested: "Submitted",
      approved: "Approved",
      accepted: "Accepted",
      denied: "Denied",
      exception: "Exception",
      undelivered: "Undelivered",
    },
  },

  get(key, language = "en") {
    return key
      .split(".")
      .reduce((o, i) => o[i], lang[language]);
  },
};

export default lang;



// WEBPACK FOOTER //
// ./resources/assets/js/lang/index.js